import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminAPI } from '../services/authService';

const ProjectsContext = createContext(null);

const safeArray = (v) => (Array.isArray(v) ? v : []);
const unwrapListResponse = (response) => {
  const body = response?.data;
  if (!body || typeof body !== 'object') return { rows: [] };
  if (Array.isArray(body)) return { rows: body };
  if (Array.isArray(body.data)) return { rows: body.data };
  return { rows: [] };
};

export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getProjects();
      const { rows } = unwrapListResponse(response);
      const mapped = safeArray(rows).map((row) => {
        const meta = row.metadata || {};
        return {
          id: row.id,
          name: row.name,
          agreement_prefix: row.agreementPrefix || row.agreement_prefix || row.code || `PRJ-${row.id}`,
          status: row.status || 'Active',
          brief_designations: Array.isArray(meta.brief_designations) ? meta.brief_designations.filter((d) => d && String(d).trim()) : [],
        };
      });
      mapped.sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
      setProjects(mapped);
    } catch (_error) {
      setProjects([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = {
    projects,
    projectsLoading: loading,
    refreshProjects: refresh,
  };

  return (
    <ProjectsContext.Provider value={value}>
      {children}
    </ProjectsContext.Provider>
  );
};

export const useProjects = () => {
  const ctx = useContext(ProjectsContext);
  if (!ctx) {
    return {
      projects: [],
      projectsLoading: false,
      refreshProjects: () => {},
    };
  }
  return ctx;
};
